import { useQuery } from '@tanstack/react-query';
import { BENEFICIARY_PASSPORTS_KEY } from 'src/utils/constants/queryKeys';
import { getBeneficiaryPassports } from '../services/fn-api/Passports';

export const useGetBeneficiaryPassports = (beneId?: number, dependentId?: number) => {
  return useQuery({
    queryKey: [BENEFICIARY_PASSPORTS_KEY, beneId, dependentId],
    queryFn: () => getBeneficiaryPassports(beneId, dependentId),
    enabled: !!(beneId || dependentId),
  });
};
